import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Typography } from '@mui/material';
import Image from 'next/image';
import { ButtonWithIcon } from '@/components/buttons/buttonWithIcon';
import { Icon } from '@/components/shared/icon';
import pinkBackgroundSpaceship from '../../../public/statics/images/illustrations/onboarding/pink_background_spaceship.png';
export const WelcomePageWrapper = t0 => {
  const $ = _c(12);
  const {
    children,
    onBack
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "100%",
      height: "100%",
      padding: "min(100px,4vw)"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "100%",
      height: "100%",
      justifyContent: "space-between"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Box className="flex items-center"><Image alt="bring-your-own-cloud" height={760} width={760} src={pinkBackgroundSpaceship} style={{
        width: "40vw",
        height: "40vw"
      }} priority={true} /></Box>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      padding: "min(100px,4vw)",
      minWidth: "50%",
      gap: "40px"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onBack) {
    t5 = onBack && <ButtonWithIcon onClick={onBack} text="Back" icon="material-symbols-chevron-left-rounded" iconPosition="left" />;
    $[4] = onBack;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      flexGrow: 1,
      justifyContent: "center"
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== children) {
    t7 = <Stack sx={t6}>{children}</Stack>;
    $[7] = children;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t7) {
    t8 = <Box sx={t1}><Stack direction="row" sx={t2}>{t3}<Stack className="bg-[white] rounded-[16px] overflow-y-auto" sx={t4}>{t5}{t7}</Stack></Stack></Box>;
    $[9] = t5;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};
export const WelcomePageListItem = t0 => {
  const $ = _c(4);
  const {
    text
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "12px",
      alignItems: "center"
    };
    t2 = <Icon iconClass="material-symbols-check" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== text) {
    t3 = <Stack direction="row" sx={t1}>{t2}<Typography variant="subtitle1">{text}</Typography></Stack>;
    $[2] = text;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};